/**
 * Environment configuration for the Outlook Add-in.
 * Values are resolved at build time via Vite's env variable handling.
 */

const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'https://api.ziviso.africa/api/v1';
const APP_URL = import.meta.env.VITE_APP_URL ?? 'https://app.ziviso.africa';
const ADDIN_URL = import.meta.env.VITE_ADDIN_URL ?? 'https://addin.ziviso.africa';

export const config = {
  /** Base URL for the Ambient API gateway. */
  apiBaseUrl: API_BASE_URL,

  /** URL for the Command Center app (used for dialog-based auth fallback). */
  appUrl: APP_URL,

  /** URL where this add-in is hosted (used in manifest). */
  addinUrl: ADDIN_URL,

  /** Signature cache TTL in milliseconds (5 minutes). */
  signatureCacheTtlMs: 5 * 60 * 1000,

  /** Auth token storage keys. */
  storageKeys: {
    accessToken: 'ambient_addin_access_token',
    refreshToken: 'ambient_addin_refresh_token',
    tokenExpiry: 'ambient_addin_token_expiry',
    signatureCache: 'ambient_addin_signature_cache',
  } as const,
} as const;
